import React from 'react';
import PageHeader from '../../components/PageHeader';


function TeacherForm(){
    return(
        <div id="page-teacher-form" className="container">
           <PageHeader title="Que incrivél que você que dá aulas."/>
        </div>
    )
}

export default TeacherForm;